import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IngresoComponent } from '../../ingreso/ingreso.component';
import { ContenedorComponent } from '../contenedor.component';
import { CrearFormularioComponent } from '../../crear-formulario/crear-formulario.component';
import { BorradoresComponent } from '../../borradores/borradores.component';
import { FraccionComponent } from '../../fraccion/fraccion.component';
import { CuotasComponent } from '../../cuotas/cuotas.component';
import { PresentadosComponent } from '../../presentados/presentados.component';
import { DefinitivosComponent } from '../../definitivos/definitivos.component';
import { SugeridaComponent } from '../../sugerida/sugerida.component';



const routes: Routes = [
	{ path: '', redirectTo: 'ingreso', pathMatch: 'full' },
    { path: 'ingreso', component: ContenedorComponent,
		children: [
			{ path: '', component: IngresoComponent },
			{ path: 'crearFormulario', component: CrearFormularioComponent },
			{ path: 'borradores', component: BorradoresComponent },
			{ path: 'presentados', component: PresentadosComponent },
			{ path: 'fraccion', component: FraccionComponent },
			{ path: 'cuotas', component: CuotasComponent },
			{ path: 'definitivos', component: DefinitivosComponent },
			{ path: 'sugerida', component: SugeridaComponent },
		]
	}
];


@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ContenedorRoutingModule { }


// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/contenedor/modules/contenedor-routing.module.ts